import OutLineMobileEight from '@assets/icons/outline-mobile-eight.svg'
import { Icon } from './Icon'

export const OutLineMobileEightIcon = Icon(OutLineMobileEight)
